import * as Yup from "yup";

export const reviewValidation = Yup.object().shape({
  user: Yup.string().required("User ID is required"),
  description: Yup.string().required("description is required"),
  ratings: Yup.number().required("ratings is required"),
});
